import _ from 'underscore';
import Backbone from 'backbone';

var MAX_HISTORY = 4;

export var SubscriptionModel = Backbone.Model.extend({
  url: 'subscription',

  initialize: function () {},

  parse: function (res) {
    var history = res.result.history;
    var dummyLen = MAX_HISTORY - history.length;

    // 최대 4개까지 노출. 4개가 안되면 공간이 남아서 더미 데이터 추가
    for (var i = 0; i < dummyLen; i++) {
      history.push({
        membershipName: '',
        paidAmount: '',
        paidDate: '&nbsp;',
        subscription: ''
      });
    }

    return _.extend({}, res.result, history);
  }
});
